import firebase from "firebase/app";
import { useState } from "react";

import "firebase/auth";

/**
 * SPWN ユーザーに紐づく start.gg 連携情報。
 * 機密トークンは保持せず、突合に使う user.id と表示名(gamerTag)だけを持つ。
 *
 * Phase 1（ログイン済みユーザーの連携デモ）ではクライアント保存＝localStorage。
 * entry 判定時にこの値を backend へ渡す（backend は link を保持しない）現アーキに沿う。
 * 運営照合のためのサーバ側永続化は Phase 2 の範疇。
 */
export type StartggLink = {
  userId: string;
  username: string;
  linkedAt: number;
};

const storageKey = (uid: string) => `startggLink:${uid}`;

const readLink = (): StartggLink | null => {
  const uid = firebase.auth().currentUser?.uid;
  if (!uid) {
    return null;
  }
  const raw = localStorage.getItem(storageKey(uid));
  if (!raw) {
    return null;
  }
  return JSON.parse(raw) as StartggLink;
};

export const useStartggLink = () => {
  const [link, setLink] = useState<StartggLink | null>(() => readLink());

  const save = (next: StartggLink): void => {
    const uid = firebase.auth().currentUser?.uid;
    if (!uid) {
      throw new Error("not logged in");
    }
    localStorage.setItem(storageKey(uid), JSON.stringify(next));
    setLink(next);
  };

  // SPWN 側の連携解除。保存した start.gg 情報を忘れる（start.gg 側の OAuth 認可の
  // 取り消しは start.gg の設定で別途行う）。
  const clear = (): void => {
    const uid = firebase.auth().currentUser?.uid;
    if (uid) {
      localStorage.removeItem(storageKey(uid));
    }
    setLink(null);
  };

  return {
    link,
    isLoading: false,
    reload: () => setLink(readLink()),
    save,
    clear,
  };
};
